<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container fluid>
        <div v-bind:class="[{ busy: busy }, 'opacity-transition']">
            <pb-spinner v-if="busy"/>
            <b-row class="mb-2">
                <b-col>
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                    ></b-pagination>
                </b-col>
                <b-col>
                    <b-form inline class="float-right">
                        <b-input-group>
                            <b-input-group-prepend is-text><i class="fal fa-search"></i></b-input-group-prepend>
                            <b-form-input size="sm" v-model="filterUsers" placeholder="Search User"
                                          class="mb-2 mb-sm-0"/>
                        </b-input-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table responsive striped small hover
                             :items="registrationItems"
                             :fields="tableFields"
                             :filter="filterUsers"
                             @filtered="onFiltered"
                             :per-page="perPage"
                             :current-page="currentPage">
                        <template v-slot:cell(Actions)="row">
                            <b-button title="Confirm Registration" variant="link"
                                      @click.stop="confirmRegistration(row.item.activationToken)"><i
                                    class="fal fa-lg fa-clipboard-check "></i></b-button>
                            <b-button title="Delete Registration" variant="link"
                                      v-b-modal.deleteRegistration
                                      @click.stop="deleteItem = row.item"><i
                                    class="fal fa-lg fa-trash-alt text-danger"></i>
                            </b-button>
                        </template>
                    </b-table>
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                    ></b-pagination>
                </b-col>
            </b-row>
        </div>
        <delete-modal v-if="deleteItem" id="deleteRegistration" @ok="deleteRegistration()"
                      @cancel="cancelDeleteRegistration">
            <template slot="content">
                Wollen Sie die Registrierung vom Benutzer <b>{{deleteItem.firstName}} {{deleteItem.lastName}}</b>
                wirklich löschen?
            </template>
        </delete-modal>
    </b-container>
</template>

<script>


    import RegistrationApi from "@shared/_api/cms/registration";
    import UserApi from "@shared/_api/user";
    import DeleteModal from "../components/DeleteModal";

    export default {
        name: "registrationsTable",
        components: {
            "delete-modal": DeleteModal,
        },
        data: function () {
            return {
                perPage: 10,
                currentPage: 1,
                totalRows: 1,
                filterUsers: '',
                tableFields: [
                    {key: 'firstName', label: 'First Name', sortable: true},
                    {key: 'lastName', label: 'Last Name', sortable: true},
                    {key: 'email', label: 'Email', sortable: true},
                    {key: 'company', label: 'Company', sortable: true},
                    {key: 'createDateTime', label: 'Registriert am', sortable: true, formatter: value => {
                            return value ? new Date(value).toLocaleDateString() : null;
                        }},
                    {key: 'Actions', class: 'align-middle table-action-column'},
                ],
                registrationItems: [],
                busy: false,
                deleteItem: null
            };
        },
        mounted() {
            this.loadOpenRegistrations();
        },
        computed: {
            deleteModalInfo: function () {
                return this.deleteItem ? `Wollen Sie die Registrierung vom Benutzer ${this.deleteItem.firstName} ${this.deleteItem.lastName} wirklich löschen?` : '';
            }
        },
        methods: {
            loadOpenRegistrations() {
                this.busy = true;
                RegistrationApi.getOpen().then(res => {
                    this.registrationItems = res;
                    this.totalRows = res.length;
                }).finally(() => {
                    this.busy = false;
                })
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            confirmRegistration(token) {
                this.busy = true;
                UserApi.activate(token).then(() => {
                    this.$bvToast.toast(`User was succecssfully confirmed.`, this.$toastSuccess);
                }).catch(() => {
                    this.$bvToast.toast(`Error confirming user.`, this.$toastDanger);
                }).finally(() => {
                    this.loadOpenRegistrations();
                });
            },
            deleteRegistration() {
                this.busy = true;
                RegistrationApi.delete(this.deleteItem.id).then(() => {
                    this.$bvToast.toast(`Item successfully deleted.`, this.$toastSuccess);
                }).catch(() => {
                    this.$bvToast.toast(`Error deleting item.`, this.$toastDanger);
                }).finally(() => {
                    this.loadOpenRegistrations();
                    this.deleteItem = null
                });
            },
            cancelDeleteRegistration() {
                this.deleteItem = null
            }
        }
    };
</script>
